import { Stack, useTheme } from "@mui/material";
import { ActivitiesEmptyState } from "web_myplann/Activities/Components/ActivitiesEmptyState";
import { ActivitiesListSkeleton } from "web_myplann/Activities/Components/ActivitiesListSkeleton";
import { ActivitiesListV2Group } from "web_myplann/Activities/Components/ActivitiesListV2Group";
import { useActivitiesList } from "web_myplann/Activities/Hooks/useActivitiesList";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { TaskKeys } from "web_myplann/Api/Tasks/TaskKeys";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { NativePullToRefresh } from "web_myplann/Shared/Components/NativePullToRefresh";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import { MyPlannNavigationHeader } from "web_myplann/Shared/Header/MyPlannNavigationHeader";

const ListResources = Resources.Activity.List;

export const ActivitiesListV2Page = () => {
	const { t } = useResource();
	const theme = useTheme();

	const {
		solvedEvents,
		upcomingEvents,
		overdueEvents,
		resolvedEvents,
		isLoading,
		allSectionsEmpty,
	} = useActivitiesList();

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.surface.muted}
			topBar={
				<MyPlannNavigationHeader
					title={t(ListResources.title)}
					bgColor={theme.palette.background.paper}
					defaultRoute={Routing.Profile.More.path()}
				/>
			}
		>
			<NativePullToRefresh
				queryKeys={[
					TaskKeys.lists(),
					ActivityKeys.lists(),
					ActivityKeys.events(),
				]}
				spinnerOffset={-20}
			>
				{isLoading && <ActivitiesListSkeleton />}

				{!isLoading && allSectionsEmpty && <ActivitiesEmptyState />}

				{!isLoading && !allSectionsEmpty && (
					<Stack pb={theme.spacingTokens.xl} data-testid="activities-list-page">
						<ActivitiesListV2Group
							id="inProgress"
							label={t(ListResources.Sections.InProgress)}
							group={solvedEvents}
							emptyText={t(ListResources.NoTask)}
						/>
						<ActivitiesListV2Group
							id="planned"
							label={t(ListResources.Sections.Planned)}
							group={upcomingEvents}
							emptyText={t(ListResources.NoPlannedActivities)}
						/>
						<ActivitiesListV2Group
							id="past"
							label={t(ListResources.Sections.Past)}
							group={overdueEvents}
							emptyText={t(ListResources.NoPastActivities)}
						/>
						<ActivitiesListV2Group
							id="closed"
							label={t(ListResources.Sections.Closed)}
							group={resolvedEvents}
							emptyText={t(ListResources.NoResolvedEvents)}
						/>
					</Stack>
				)}
			</NativePullToRefresh>
		</MyPlannLayout>
	);
};
